export const goTo = ({ payload }, store, { router }) => {
  router.push(payload)
}

export const logout = (actions, store) => {
  store.config.keycloak.get().logout()
}

export const onRouterPush = ({ payload }, store) => {
  const [name, subName] = payload.code.split('_')
  store.ui.screen.name.set(name)
  if (subName) {
    store.ui.screen.subName.set(subName)
  } else {
    store.ui.screen.subName.reset()
  }
}
